import React, {useState} from "react";
import axios from "config/axiosConfig";
import {toast} from "react-toastify";

export default function ExcelUpload() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const downloadTemplate = () => {
        axios.get("/admin/v1/members/excel/download", { responseType: "blob" })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "member_template.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch((err) => {
                console.error(err);
                toast.error("양식 다운로드에 실패했습니다.");
            });
    };

    const handleUpload = () => {
        if (!file) {
            alert("파일을 선택해주세요.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        setResults([]);

        axios.post("/admin/v1/members/excel/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then((res) => {
            setResults(res.data);
            toast.success("엑셀 업로드가 완료되었습니다.");
        })
        .catch((err) => {
            console.error(err);
            toast.error("업로드 중 오류가 발생했습니다.");
        })
        .finally(() => {
            setLoading(false);
        });
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 > 엑셀 대량 생성</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">엑셀 업로드</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>1. 양식 다운로드</label><br/>
                                                <button className="btn btn-info" onClick={downloadTemplate}>
                                                    <i className="fas fa-download"></i> 샘플 엑셀 양식 받기
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>2. 파일 선택 및 업로드</label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input type="file" className="custom-file-input" accept=".xlsx" onChange={handleFileChange} />
                                                        <label className="custom-file-label">{file ? file.name : "파일을 선택하세요"}</label>
                                                    </div>
                                                    <div className="input-group-append">
                                                        <button className="btn btn-primary" onClick={handleUpload} disabled={loading || !file}>
                                                            {loading ? "업로드 중..." : "업로드 실행"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {results.length > 0 && (
                                <div className="card mt-4">
                                    <div className="card-header">
                                        <h3 className="card-title">업로드 결과 리포트</h3>
                                    </div>
                                    <div className="card-body table-responsive p-0">
                                        <table className="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Email</th>
                                                    <th>결과</th>
                                                    <th>메시지</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {results.map((res, index) => (
                                                    <tr key={index}>
                                                        <td>{res.email}</td>
                                                        <td>
                                                            {res.success ? 
                                                                <span className="badge badge-success">성공</span> : 
                                                                <span className="badge badge-danger">실패</span>
                                                            }
                                                        </td>
                                                        <td>{res.message}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
